import React from 'react';

interface StepProgressProps {
  currentStep: number;
  totalSteps: number;
  label: string;
}

const StepProgress: React.FC<StepProgressProps> = ({
  currentStep,
  totalSteps,
  label,
}) => {
  const percentage = ((currentStep + 1) / totalSteps) * 100;

  return (
    <div className="bg-white rounded-lg shadow-md p-4">
      <div className="flex items-center justify-between text-sm text-gray-500 mb-2">
        <span>
          Paso {currentStep + 1} de {totalSteps}
        </span>
        <span>{label}</span>
      </div>
      <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          data-testid="step-progress-bar"
          className="h-full bg-blue-600 transition-all"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default StepProgress;
